<template>
  <div class="iot">
    <el-row :gutter="30">
      <el-form inline :label-position="'top'">
        <el-col :span="3" v-if="point.device && point.profile">
          <el-form-item style="margin-top: 20px">
            <el-button style="margin-left: 20px" type="primary" size="mini" icon="el-icon-refresh"
              @click="updateScanResults()" :loading="updateScanResultsLoading">
              {{ $t("common.refresh") }}</el-button>
          </el-form-item>
          <br />
          <span style="
              margin-left: 20px;
              float: left;
              font-size: 12px;
              position: absolute;
              font-style: italic;
              display: block;
              margin-top: -20px;
            " v-show="showNoRouting">{{ $t("iot.no_routing_found") }}</span>
          <br />
        </el-col>
        <el-col :span="4" v-if="point.device && point.profile && routingData.length">
          <el-form-item :label="$t('admin.gateways')">
            <el-select v-model="selectedGateway" placeholder="Select" clearable default-first-option>
              <el-option v-for="item in routingData" :label="item._id.gateway" v-bind:key="item._id.gateway"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-if="point.device && point.profile && selectedGateway">
          <el-form-item :label="$t('point.quality')">
            <signalQuality :rssi="selectedGateway.rssi"></signalQuality>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-if="point.device && point.profile && selectedGateway">
          <el-form-item :label="$t('point.status')">
            <el-tag v-show="
              selectedGateway.status &&
              selectedGateway.status.toLowerCase() != 'unknown'
            " size="small" :type="tagStatus(selectedGateway.status.toLowerCase())">{{ selectedGateway.status }}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="2" v-if="point.device && point.profile && selectedGateway">
          <el-form-item :label="' '">
            <el-button :disabled="
              !selectedGateway.status ||
              (selectedGateway.status.toLowerCase() != 'ready' &&
                selectedGateway.status.toLowerCase() != 'connected')
            " size="small" @click="measureDialog = true" type="primary" style="height: 40px; margin-top: 10px">{{
    $t("point.measure")
}}</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <p v-if="
            selectedGateway.status &&
            selectedGateway.status.toLowerCase() == 'ready' &&
            measurementId
          ">
            <em class="el-icon-loading"></em>
            <span v-show="postprocessing">Post-processing</span>
          </p>
          <p v-if="lastMeasurementId">
            <router-link :to="{ name: 'measurement', params: { id: lastMeasurementId } }">Go Last Measurement
            </router-link>
          </p>
        </el-col>
      </el-form>
    </el-row>

    <el-dialog width="30%" :title="'Measure'" :visible.sync="measureDialog">
      <el-form>
        <el-form-item :label="$t('point.addTags')">
          <el-input-tag v-model="tags"></el-input-tag>
        </el-form-item>
        <el-form-item>
          <el-button @click="measure">{{ $t("point.measure") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import adminService from "../service/admin";
import { mapActions } from "vuex";
// import routingLookupService from "../service/routingLookupService";
import mqtt from "mqtt";
import signalQuality from "../components/signalQuality";
export default {
  name: "iot",
  props: ["point"],
  components: { signalQuality },
  data() {
    return {
      updateScanResultsLoading: false,
      showNoRouting: false,
      measureDialog: false,
      tags: [],
      postprocessing: false,
      scanResultAvailable: false,
      routingData: [],
      batteryLevel: [],
      selectedGateway: "",
      measurementId: "",
      lastMeasurementId: "",
      rssi: "",
      status: "unknwon",
      connecting: false,
      connected: false,
    };
  },
  computed: {},
  beforeDestroy() {
    if (this.mqttClient) {
      this.mqttClient.end(true);
    }
  },
  created() {
    if (this.mqttClient) {
      this.mqttClient.end();
    }
  },
  methods: {
    ...mapActions("device", ["getRoutingLookup"]),
    uppercaseObjectKeys(obj) {
      if (!obj) return obj;
      let entries = Object.entries(obj);
      let capsEntries = entries.map((entry) => [
        entry[0].toUpperCase(),
        entry[1],
      ]);
      obj = Object.fromEntries(capsEntries);
      return obj;
    },
    disconnect() {
      this.connecting = false;
      this.connected = false;
      if (this.mqttClient) {
        this.mqttClient.end(true);
      }
    },
    async measure() {
      this.measurementTimeout = setTimeout(() => {
        this.measuring = false;
        this.measurementId = "";
        this.postprocessing = false;
        if (this.mqttClient) {
          this.mqttClient.end(true);
        }
        this.connecting = false;
        this.$message.error("IoT timeout");
      }, 60000);

      await this.initiateMqtt();
    console.log(this.point)
      let url = `${process.env.VUE_APP_APIURL}/iot/${this.point._id}/measure`;
      if (this.point.connectedDevice.type == 'DUCKV1') {
        url = `${process.env.VUE_APP_APIURL}/duck/${this.point.device.macAddress}/measure`;
      }
      axios
        .post(url, {
          tags: this.tags,
          gateway: this.selectedGateway._id.gateway,
        })
        .then((res) => {
          this.measurementId = res.data._id;
          this.measureDialog = false;
        })
        .catch((e) => {
          this.$mesasge.error(e.response.data.message);
          this.measuring = false;
        });
    },
    tagStatus(status) {
      var type = "default";
      status = status.toLowerCase();
      switch (status) {
        case "unknown":
          type = "info";
          break;
        case "measuring":
          type = "success";
          break;
        case "sleeping":
          type = "warning";
          break;
        case "ready":
          type = "";
          break;
      }
      return type;
    },
    onMessage(topic, payload) {
      let messageString = payload.toString();
      let topicTokens = topic.split("/");
      // console.log(topic, payload,topicTokens.length);

      if (
        topicTokens.length === 8 &&
        topicTokens[1] === "gateway" &&
        topicTokens[2] === this.selectedGateway._id.gateway &&
        topicTokens[3] === "device" &&
        topicTokens[4] === this.point.device.macAddress &&
        topicTokens[5] === "measure" &&
        topicTokens[6] === this.measurementId &&
        topicTokens[7] === "done"
      ) {
        this.postprocessing = true;
        this.measuring = false;
      } else if (
        topicTokens.length === 8 &&
        topicTokens[1] === "gateway" &&
        topicTokens[2] === this.selectedGateway._id.gateway &&
        topicTokens[3] === "device" &&
        topicTokens[4] === this.point.device.macAddress &&
        topicTokens[5] === "measure" &&
        topicTokens[6] === this.measurementId &&
        topicTokens[7] === "accepted"
      ) {
        this.selectedGateway.status = "measuring";
        this.measuring = true;
        clearTimeout(this.measurementTimeout);
      } else if (
        topicTokens.length === 8 &&
        topicTokens[1] === "gateway" &&
        topicTokens[2] === this.selectedGateway._id.gateway &&
        topicTokens[3] === "device" &&
        topicTokens[4] === this.point.device.macAddress &&
        topicTokens[5] === "measure" &&
        topicTokens[6] === this.measurementId &&
        topicTokens[7] === "rejected"
      ) {
        this.updateScanResults();
        this.postprocessing = false;
        this.measuring = false;
        this.measurementId = false;
        // let measurementId = topicTokens[5]
        // let macAddress = topicTokens[3]
        this.$notify({
          title: "Measurement Error",
          type: "error",
          customClass: "notification",
          dangerouslyUseHTMLString: false,
          message: messageString,
          duration: 5000,
        });
        this.postprocessing = true;

        clearTimeout(this.measurementTimeout);
        this.measuring = false;
      } else if (
        topicTokens.length === 8 &&
        topicTokens[1] === "gateway" &&
        topicTokens[2] === this.selectedGateway._id.gateway &&
        topicTokens[3] === "device" &&
        topicTokens[4] === this.point.device.macAddress &&
        topicTokens[5] === "measure" &&
        // topicTokens[6] === this.measurementId &&
        topicTokens[7] === "persisted"
      ) {
        clearTimeout(this.measurementTimeout);
        setTimeout(() => this.updateScanResults(), 500);
        let macAddress = topicTokens[4];
        let measurementId = topicTokens[6];
        this.$notify({
          title: "Measurement Ready",
          type: "success",
          customClass: "notification",
          onClick: this.openMeasurement,
          dangerouslyUseHTMLString: true,
          message: `<a onClick='window.open(window.location.origin + "/measurement/${measurementId}","_blank")'> Measurement done for <b>${macAddress}</b> Click to go details</a>`,
          duration: 15 * 1000
        });
        this.postprocessing = false;
        this.lastMeasurementId = measurementId;
        this.measurementId = "";
        this.updateScanResults();
      }
    },
    updateScanResults() {
      this.updateScanResultsLoading = true;
      this.measurementId = "";
      // routingLookupService
      //   .getRoutingLookup(this.point.device.macAddress)
      this.getRoutingLookup(this.point.device.macAddress)
        .then((res) => {
          this.batteryLevel = res.data.batteryLevel;
          this.routingData = res.data.data;
          if (!this.routingData.length) {
            this.selectedGateway = "";
            this.showNoRouting = true;
            setTimeout(() => (this.showNoRouting = false), 3000);
          }
          if (this.selectedGateway) {
            let alreadySelected = this.routingData.find(
              (x) => x._id.gateway == this.selectedGateway._id.gateway
            );
            this.selectedGateway = alreadySelected;
          }
        })
        .finally(() => (this.updateScanResultsLoading = false));
    },
    initiateMqtt() {
      // eslint-disable-next-line no-unused-vars
      return new Promise((res, rej) => {
        this.disconnect();
        adminService
          .getSigv4Url()
          .then((x) => {
            this.connecting = true;

            var self = this;
            if (self.mqttClient) {
              self.mqttClient.end(true);
            }
            self.mqttClient = mqtt.connect(x.url, {
              protocol: "wss",
              clientId: self.$uuid.v1(),
            });

            self.mqttClient.on("connect", () => { });
            self.mqttClient.once("error", (e) => {
              self.$mesasge.info("error occured", e);
            });
            self.mqttClient.on("error", () => {
              self.$message.error("Someting went wrong");
            });
            self.mqttClient.on("reconnect", () => { });
            self.mqttClient.on("close", () => { });
            self.mqttClient.on("disconnect", () => { });
            self.mqttClient.on("offline", () => { });
            self.mqttClient.on("message", self.onMessage);
            var gatewayOperations = `${process.env.VUE_APP_TOPICPREFIX}/gateway/${this.selectedGateway._id.gateway}/device/${this.point.device.macAddress}/measure/+/+`;
            self.mqttClient.subscribe([gatewayOperations], (err) => {
              if (!err) {
                res("ok");
              } else {
                console.log(err);
              }
            });
          })
          .catch((e) => {
            console.log(e);
            this.connecting = false;
          });
      });
    },
  },
};
</script>
<style>
.iot {
  margin-top: -15px;
}

.iot li {
  list-style-type: none;
  margin-bottom: 10px;
}

.iot .el-row {
  padding: 5px;
  margin-bottom: 5px;
}

.el-notification__content {
  text-align: left;
}

.el-notification {
  width: 360;
}
</style>

